import React, { useState, useEffect } from "react";
import ThreeScene from "./ThreeScene"; // 👈 componente 360

declare const window: any;

interface VistaAptoProps {
  isSelectedAptoView: any;
  setIsSelectedAptoView: (value: any) => void;
  theme: string;
}

// 🔹 Hook para detectar si una imagen es 360° (6000x3000 o proporción 2:1)
const useIsRender360 = (imageUrl: string) => {
  const [isRender360, setIsRender360] = useState<boolean | null>(null);

  useEffect(() => {
    if (!imageUrl) return;
    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      const { width, height } = img;
      const isExact360 =
        Math.abs(width - 6000) <= 10 && Math.abs(height - 3000) <= 10;
      const ratio = width / height;
      const isRatio360 = ratio > 1.95 && ratio < 2.05;
      setIsRender360(isExact360 || isRatio360);
    };

    img.onerror = () => setIsRender360(false);
  }, [imageUrl]);

  return isRender360;
};

const VistaDeInmueblesContainer: React.FC<VistaAptoProps> = ({
  isSelectedAptoView,
  theme
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imagenes, setImagenes] = useState<string[]>([]);
  const [selectedFile, setSelectedFile] = useState<any>(null);

  useEffect(() => {
    if (!isSelectedAptoView?.galleries?.length) return;

    // 🔍 Buscar la galería cuyo tipo sea "Vistadeinmuebles"
    const galeriaSeleccionada = isSelectedAptoView.galleries.find(
      (g: any) => g.type === "Vistadeinmuebles"
    );

    if (!galeriaSeleccionada || !galeriaSeleccionada.links?.length) return;

    // Crear los links de imágenes
    const links = galeriaSeleccionada.links.map(
      (img: any) =>
        `${window.hybrid ? "./" : "https://d1bsymnertnea6.cloudfront.net/"}${img.link}`
    );

    setImagenes(links);
    setCurrentIndex(0);
    setSelectedFile(galeriaSeleccionada.links[0]);
  }, [isSelectedAptoView]);

  useEffect(() => {
    if (!imagenes.length || !isSelectedAptoView?.galleries?.length) return;

    const galeriaSeleccionada = isSelectedAptoView.galleries.find(
      (g: any) => g.type === "Vistadeinmuebles"
    );

    if (galeriaSeleccionada)
      setSelectedFile(galeriaSeleccionada.links[currentIndex]);
  }, [currentIndex, imagenes, isSelectedAptoView]);

  const imageUrl = selectedFile
    ? `${window.hybrid ? "./" : "https://d1bsymnertnea6.cloudfront.net/"}${
        selectedFile.link
      }`
    : "";

  const isRender360 = useIsRender360(imageUrl);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % imagenes.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + imagenes.length) % imagenes.length);
  };

  if (!imagenes.length) return null; // 🧠 no hay galería de tipo "Vistadeinmuebles"

  

  return (
    <div className={`galeria-de-inmuebles ${theme}`}>
      {isRender360 ? (
        <ThreeScene
          key={`three-${selectedFile.link}`}
          selectedFile={`${
            window.hybrid
              ? "./" + selectedFile.link
              : "https://d1bsymnertnea6.cloudfront.net/" +
                encodeURIComponent(selectedFile.link)
          }`}
        />
      ) : (
        <img
          src={imageUrl}
          alt={`Vista ${currentIndex + 1}`}
          className="galeria-de-inmuebles__imagen"
        />
      )}

      <div className="galeria-de-inmuebles__controles">
        <button onClick={prevImage}>‹</button>
        <span>
          {currentIndex + 1} / {imagenes.length}
        </span>
        <button onClick={nextImage}>›</button>
      </div>
    </div>
  );
};

export default VistaDeInmueblesContainer;
